import { getConfigValue } from 'utils/environment';

export enum AddressFormatType {
  /*
    The name of the street is before the number.
    Eg: Silver Lane 12
  */
  NameNumber = 'name_number',

  /*
    The name of the street is after the number.
    Eg: 12 Silver Lane
  */
  NumberName = 'number_name',
}

export const useAddressFormat = () => {
  const addressFormat: AddressFormatType =
    (getConfigValue('addressFormat') as AddressFormatType) || AddressFormatType.NameNumber;

  return addressFormat;
};
